<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon">
      <i class="fi fi-ss-search-alt"></i>
      {{"MSDCIQC.Header" | translate}}
    </span>
  </h1>
</div>

<p-card>
  <p-accordion>
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
      <form [formGroup]="searchForm">
        <div class="p-fluid formgrid grid">

          <div class="col-12 md:col-6 lg:col-4 mb-3">
            <label>{{ 'MSDCIQC.Search.ScanId' | translate }}</label>
            <input pInputText type="text" formControlName="scanId">
          </div>

          <div class="col-12 md:col-6 lg:col-4 mb-3">
            <div class="font-bold mt-0 mb-4">{{ 'MSDCIQC.Search.Type' | translate }}</div>
            <div class="grid">
              <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-2 lg:col-6">
                <p-radioButton formControlName="msdcType" value="1" label="{{ 'MSDCIQC.Search.Unseal' | translate }}"></p-radioButton>
              </div>
              <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-2 lg:col-6">
                <p-radioButton formControlName="msdcType" value="2" label="{{ 'MSDCIQC.Search.Seal' | translate }}"></p-radioButton>
              </div>
            </div>
          </div>

        </div>

        <div>
          <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" (click)="confirmBtnClick($event)">
          </button>
          <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn($event)"
            class="p-button-secondary ml-2">
          </button>
        </div>

      </form>
    </p-accordionTab>
  </p-accordion>


  <div class="mt-2">

    <laas-data-table
     #MSDCDataTable
     [tableKey]="preferenceKey"
     [(selectedRows)]="selectRow"
     [defaultColumns]="tableColumns"
     [value]="tableValue"
     [totalRecords]="this.pageInfo.totalRecords"
     dataKey="rowId"
     (tableOnPage)="this.tablePageChange($event)"
     (tableOnSort)="this.tableSort($event)"
     [loading]="isLoading"
     [lazy]="true"
     (setPageSize)="setPageSize($event)"
     [rows]="25"
     styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;">

      <ng-template pTemplate="body" let-columns="columns" let-rowData>

        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">

            <ng-container *ngSwitchDefault class="p-fluid">

              <ng-container [ngSwitch]="col.dataType">
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith:'-'}}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date: "yyyy-MM-dd HH:mm:ss":this.laasSetting.facilityTimeZone |
                    replaceNullWith: "-" }}
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>


          </ng-container>
        </td>

      </ng-template>

    </laas-data-table>

  </div>

</p-card>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
